import {StyleSheet} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#fff',
    padding: 24,
    paddingBottom: 8,
  },
  header: {
    marginHorizontal: 10,
    marginBottom: 10,
    position: 'relative',
  },
  logo: {
    position: 'absolute',
    right: 0,
    bottom: -10,
    width: 100,
  },
  title: {
    fontSize: 12,
  },
  date: {
    fontSize: 9,
    marginBottom: 2,
  },
  table: {
    border: 1,
    marginBottom: 2,
  },
  sectionHeader: {
    backgroundColor: '#ccc',
    paddingLeft: 3,
    paddingVertical: 2,
    borderTop: 1,
  },
  contentSection: {
    paddingHorizontal: 3,
    paddingVertical: 2,
    borderTop: 1,
    justifyContent: 'center',
  },
  smallContent: {
    paddingHorizontal: 1,
  },
  smallCheck: {
    paddingHorizontal: 1,
    paddingLeft: 0,
    borderLeft: 0,
    width: '1.5%',
  },
  text: {
    fontSize: 8,
    display: 'flex',
  },
  text10: {
    fontSize: 10,
    display: 'flex',
  },
  bold: {
    fontFamily: 'Helvetica-Bold',
  },
  center: {
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  verticalCenter: {
    justifyContent: 'center',
  },
  row: {
    flexDirection: 'row',
  },
  width51: {
    width: '51%',
  },
  width60: {
    width: '60%',
  },
  nrRendor: {
    width: '40%',
    backgroundColor: '#fff',
    borderLeftWidth: 1,
  },
  borderLeft: {
    borderLeft: 1,
  },
  noBorder: {
    borderTop: 0,
  },
  noPadding: {
    paddingHorizontal: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  flex1: {
    flex: 1,
  },
  flex2: {
    flex: 2,
  },
  flex3: {
    flex: 3,
  },
  width3: {
    width: '3%',
  },
  width5: {
    width: '5%',
  },
  width35: {
    width: '35%',
  },
  width31: {
    width: '31.5%',
  },
  width65: {
    width: '65%',
  },
  checkContent: {
    width: '70%',
    height: '70%',
    borderRadius: 4,
    border: 1,
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  footer: {
    marginTop: 'auto',
  },
  footerSign: {
    width: '40%',
  },
  borderBottom: {
    borderBottom: 1,
  },
  uplift: {
    marginTop: 4,
    marginBottom: 6,
    letterSpacing: 1,
  },
  info: {
    fontSize: 7,
  },
  rotated: {
    transform: 'rotate(-90deg)',
  },
});

export default styles;
